
import OrderProductImage from '@marketplace/components/account/orders/parts/order-product-image.vue'
import ProductQuantityIncrementor from '@marketplace/components/product/product-quantity-incrementor.vue'

export default {
    name: 'OrderProductIssueRow',

    components: {
        ProductQuantityIncrementor,
        OrderProductImage,
    },

    props: {
        node: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            productSelected: false,
            quantity: 0,
            maxQuantity: this.node?.quantity || 0,
        }
    },

    computed: {
        displayedProductTitle() {
            return this.node?.listing?.title || this.node.title || ''
        },
        displayedProductImage() {
            return this.node.images?.edges?.[0]?.node?.transformedUrl
        },
    },

    methods: {
        quantityCallback(quantity) {
            this.quantity = quantity
            this.inputUpdated()
        },
        inputUpdated() {
            this.productSelected = !!+this.quantity
            this.$emit('rowCallback', {
                id: this.node.id,
                isSelected: this.productSelected,
                quantity: this.quantity,
            })
        },
    },
}
